import { MainService } from './../_services/main.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ApiService } from './../_services/api.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse, HttpHeaders
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, retryWhen, switchMap } from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  requests = [];
  isRefreshing: any;
  refreshTokenSubject: any;
  constructor(private api: ApiService, private main: MainService, private router: Router, private tostr: ToastrService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log("Interceptiong", request)
    const req = this.addAuthHeader(request);
    return next.handle(req).pipe(catchError(error => {
      return this.handleResponseError(error, request, next);
    }), map(result => {
      if (result.body && result.body.data?.access_token) {
        localStorage.setItem('aios', result.body.data.access_token);
      }
      return result;
    })
    );
  }

  handleResponseError(error: HttpErrorResponse, request?: HttpRequest<unknown>, next?: HttpHandler): Observable<any> {
    // Business error
    if (error.status === 400) {
      this.tostr.info(error.error.data[0]?.msg || error.error.message);
      this.router.navigate(this.router.url.split('?')[0].split('/'));
    }
    // Invalid token error
    else if (error.status === 401) {
      this.logout();
      // return this.api.refreshToken().pipe(
      //   switchMap(() => {
      //     request = this.addAuthHeader(request as any);
      //     return (next as any).handle(request);
      //   }),
      //   catchError(e => {
      //     if (e.status !== 403) {
      //       return this.handleResponseError(e);
      //     } else {
      //       this.logout();
      //     }
      //     return false as any;
      //   }));
    }

    // Access denied error
    else if (error.status === 403) {
      // Show message
      this.tostr.error(error.error.message || 'Session expired, Please login again');
      this.logout();
    }

    // Server error
    else if (error.status === 500) {
      this.tostr.error(error.error.message || 'Something went wrong');
    }

    // Maintenance error
    else if (error.status === 503) {
      // Show message
      this.tostr.error(error.error.message || 'Temporary down for maintenance');
      console.error(error.message);
      // Redirect to the maintenance page
    }
    else {
      this.tostr.error(error.error.message || 'Service Unavailable!!');
    }
    return throwError(error);
  }
  logout(): void {
    localStorage.removeItem('aios');
    localStorage.removeItem('aios_refresh');
    this.router.navigate(['/', 'auth', 'login']);
  }

  addAuthHeader(request: HttpRequest<any>): HttpRequest<unknown> {

    if (request.url.endsWith('auth/login') || request.url.endsWith('auth/signup')) {
      const authHeader = new HttpHeaders({
        'Content-Type': 'application/json',
      });
      if (authHeader) {
        return request.clone({ headers: authHeader });
      }
    }
    else if (request.url.endsWith('saveTemplate') || request.url.endsWith('saveMediaFile') || request.url.endsWith('sms/template/upload')) {
      console.log("here")
      const authHeader = new HttpHeaders({
        Authorization: `Bearer ${request.url.endsWith('/api/auth/refresh') || request.url.endsWith('/api/auth/logout') ? localStorage.getItem('aios_refresh') : localStorage.getItem('aios')}`,
      });
      if (authHeader) {
        return request.clone({ headers: authHeader });
      }
    }
    else {
      const authHeader = new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${request.url.endsWith('/api/auth/refresh') || request.url.endsWith('/api/auth/logout') ? localStorage.getItem('aios_refresh') : localStorage.getItem('aios')}`
      });
      if (authHeader) {
        return request.clone({ headers: authHeader });
      }
    }
    return request;
  }
}
